<template>
  <div class="content-container">
    <div class="table-wrapper">
      <a-row type="flex" justify="space-between" style="margin-bottom: 20px">
        <a-col :span="18">
          <a-form-model layout="inline">
            <a-form-model-item>
              <a-radio-group
                v-model="teamType"
                button-style="solid"
                v-if="isTeam"
                @change="changeMember"
              >
                <a-radio-button :value="1">個人作品</a-radio-button>
                <a-radio-button :value="2">團隊作品</a-radio-button>
                <a-radio-button :value="3">協同作品</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item>
              <a-radio-group
                v-model="workType"
                button-style="solid"
                @change="changeWorkType"
              >
                <a-radio-button :value="1" :class="{ changeWorkTypeBtn: workType === 1 }">一般作品</a-radio-button>
                <a-radio-button :value="3" :class="{ changeWorkTypeBtn: workType === 3 }">3D作品</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item
              class="search-work-style"
              :label="$t('form.common.field.workName.label')"
            >
              <a-input
                v-model="searchForm.name"
                :placeholder="$t('form.common.field.workName.message')"
                style="width: 200px"
              />
              <a-button
                type="primary"
                style="margin-left: 15px"
                @click="search"
              >
                {{ $t(`actionTitles.search`) }}
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </a-col>
        <a-col :span="6">
          <div
            class="btn-right-boxs"
            v-if="
              isTeam == 0 ||
              (isTeam && (userInfo.is_team_admin || teamType == 1))
            "
          >
            <a-button
              type="primary"
              @click="createFolder"
              v-if="isTeam == 0 && folderDepthList.length < 2"
            >
              {{ $t(`actionTitles.newFolder`) }}
            </a-button>

            <a-dropdown placement="bottomCenter">
              <a-menu slot="overlay" @click="handleChange" style="width: 120px">
                <a-menu-item key="delete">
                  {{ $t('actionTitles.delete') }}
                </a-menu-item>
                <a-menu-item key="moveTo" v-if="isTeam == 0">
                  {{ $t('actionTitles.moveTo') }}
                </a-menu-item>
              </a-menu>
              <a-button class="more-operate-btn">
                {{ $t('actionTitles.moreOperate') }}
                <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </div>
        </a-col>
      </a-row>

      <clear-selected
        alert-type="error"
        :show="selectedRowKeys.length > 0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      />
      <a-row>
        <a-breadcrumb>
          <a-breadcrumb-item>
            <a @click="queryByPid(0)">{{ $t('moduleTitles.root') }}</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item
            v-for="(item, index) in folderDepthList"
            :key="index"
          >
            <a @click="queryByPid(item.id)">{{ item.name }}</a>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </a-row>
      <a-table
        :row-selection="
          isTeam == 0 || (isTeam && (userInfo.is_team_admin || teamType == 1))
            ? rowSelection
            : null
        "
        :data-source="tableData"
        :rowKey="rowKey"
        :pagination="pagination"
        @change="handleTableChange"
        :customRow="customRow"
      >
        <a-table-column
          key="name"
          :title="$t('table.common.thead.name')"
          data-index="name"
        >
          <template slot-scope="text, record">
            <a-row
              v-if="record.release === undefined"
              type="flex"
              align="middle"
            >
              <a-icon
                v-if="record.dir_id == undefined"
                type="folder"
                theme="filled"
                style="
                  color: #1790ff;
                  font-size: 40px;
                  margin-right: 10px;
                  cursor: pointer;
                "
                @click="toFolder(record)"
              />
              <div
                class="imgMerge"
                v-if="workType === 3 && record.dir_id !== undefined"
              >
                <img src="@/assets/img/3Dicon.png" class="icon3D" />
                <img
                  :src="record.thumb_path"
                  alt
                  style="width: 40px; margin-right: 10px; cursor: pointer"
                  @click="toTour(record)"
                  class="overlayImg"
                />
              </div>
              <img
                v-else
                :src="record.thumb_path"
                alt
                style="width: 40px; margin-right: 10px; cursor: pointer"
                @click="toTour(record)"
              />
              <div v-if="record.dir_id == undefined">
                <span @click="toFolder(record)" class="toFolder">
                  {{ record.name }}
                </span>
              </div>
              <div v-else>
                <span
                  @click="toTour(record)"
                  class="toFolder"
                  :class="{ newName: workType === 3 }"
                >
                  <span v-if="showNew(record)" class="newYellow">new</span>
                  {{ record.name }}
                </span>
                <br />
                <span>{{ record.region_name }}</span>
              </div>
            </a-row>
            <a-row v-else type="flex" align="middle">
              <a-col :span="14" class="release">
                <img :src="record.thumb_path" alt />
                <div class="workName">
                  <span>{{ record.name }}</span>
                  <br />
                  <span>{{ record.create_time }}</span>
                </div>
              </a-col>
              <a-col class="progress" :span="10">
                <img src="@/assets/img/publishing.gif" />
                <p>{{ $t('message.workAwait') }}</p>
              </a-col>
            </a-row>
          </template>
        </a-table-column>
        <a-table-column
          key="customer_name"
          :title="$t('table.work.thead.customerName')"
          data-index="customer_name"
          align="center"
        >
          <template slot-scope="text, record">
            <div v-if="record.customer_name">
              <span>{{ record.customer_name }}</span>
              <br />
              <span>{{ record.customer_phone }}</span>
            </div>
            <span v-else>-</span>
          </template>
        </a-table-column>
        <a-table-column
          key="total_browse"
          :title="$t('table.work.thead.readCount')"
          data-index="total_browse"
          :sorter="true"
          align="center"
        >
          <template slot-scope="text, record">
            {{ record.total_browse != undefined ? record.total_browse : '-' }}
          </template>
        </a-table-column>
        <a-table-column
          key="is_public"
          :title="$t('table.common.thead.state')"
          data-index="is_public"
          :filters="filters"
          align="center"
        >
          <template slot-scope="text, record">
            {{
              record.is_public != undefined
                ? $t(`enum.workIsPublic.${record.is_public}`)
                : '-'
            }}
          </template>
        </a-table-column>
        <a-table-column
          key="create_time"
          :title="$t('table.common.thead.createTime')"
          :sorter="true"
          data-index="create_time"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.create_time ? record.create_time : '-' }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="recommend"
          :title="$t('table.common.thead.recommend')"
          :sorter="true"
          data-index="recommend"
          align="center"
          v-if="userInfo.store_id === ''"
        >
          <template slot-scope="text, record">
            <div v-if="record.dir_id != undefined">
              <a-icon
                v-if="record.recommend == 0"
                @click="recommend(record)"
                style="color: red"
                type="close"
              />
              <a-icon
                v-else
                style="color: green"
                @click="recommend(record)"
                type="check"
              />
            </div>
            <div v-else>-</div>
          </template>
        </a-table-column>
        <a-table-column
          key="thing_no"
          title="物件編號"
          data-index="thing_no"
          align="center"
          v-if="userInfo.store_id != ''"
        >
          <template slot-scope="text, record">
            <!-- <div v-if="record.text" @click="clickThingNo(record)">
              {{ text == "" ? "點擊新增" : text }}
            </div> -->
            <div
              v-if="text"
              @click="clickThingNo(record, 'edit')"
              style="cursor: pointer"
            >
              {{ text }}
            </div>
            <div
              v-else
              @click="clickThingNo(record, 'bind')"
              style="cursor: pointer"
            >
              新增
            </div>
          </template>
        </a-table-column>
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <div v-if="record.release === undefined">
              <span v-if="record.dir_id == undefined">
                <a @click="handleRename(record)">
                  {{ $t('actionTitles.rename') }}
                </a>
                <a-divider type="vertical" />

                <a-popconfirm
                  placement="top"
                  :ok-text="$t('actionTitles.yes')"
                  :cancel-text="$t('actionTitles.no')"
                  @confirm="handleDelete(record, 'dir')"
                >
                  <template slot="title">
                    {{ $t('message.deleteHint') }}
                  </template>
                  <a style="color: red">{{ $t('actionTitles.delete') }}</a>
                </a-popconfirm>
              </span>
              <span v-else>
                <a @click="share(record)">
                  {{ $t('actionTitles.share') }}
                </a>
                <a-divider type="vertical" />

                <a
                  v-if="
                    record.type == 1 &&
                    (isTeam == 0 ||
                      (isTeam && (userInfo.is_team_admin || teamType == 1)) ||
                      teamType == 3)
                  "
                  @click="onClickEdit(record)"
                >
                  {{ $t('actionTitles.edit') }}
                </a>
                <a-divider
                  v-if="
                    record.type == 1 &&
                    (isTeam == 0 ||
                      (isTeam && (userInfo.is_team_admin || teamType == 1)) ||
                      teamType == 3)
                  "
                  type="vertical"
                />

                <a
                  v-if="teamType === 1 && isTeam"
                  @click="designate(record)"
                >
                  {{ $t('actionTitles.designate') }}
                </a>
                <a-divider v-if="teamType === 1 && isTeam" type="vertical" />

                <a
                  v-if="
                    record.type == 1 &&
                    (isTeam > 0 || (isTeam == 0 && userInfo.level > 0)) &&
                    userInfo.store_id == ''
                  "
                  @click="offlineDownload(record)"
                >
                  {{ $t('actionTitles.offlineDownload') }}
                </a>
                <a-divider
                  v-if="
                    record.type == 1 &&
                    (isTeam > 0 || (isTeam == 0 && userInfo.level > 0)) &&
                    userInfo.store_id == ''
                  "
                  type="vertical"
                />

                <a @click="talk(record.id)">
                  {{ $t('actionTitles.talk') }}
                </a>
                <a-divider
                  type="vertical"
                  v-if="
                    isTeam == 0 ||
                    (isTeam && (userInfo.is_team_admin || teamType > 0))
                  "
                />

                <a
                  v-if="!record.is_model_3d == 1 && record.type == 1"
                  @click="pay3D(record)"
                >
                  {{ $t('actionTitles.workUpgrade') }}
                </a>
                <a-divider
                  v-if="!record.is_model_3d == 1 && record.type == 1"
                  type="vertical"
                />

                <a
                  v-if="record.type == 1"
                  @click="copy(record)"
                >
                  {{ $t('actionTitles.copy') }}
                </a>
                <a-divider
                  v-if="!record.is_model_3d == 1 && record.type == 1"
                  type="vertical"
                />

                <!-- 刪除確認框-->
                <a-popconfirm
                  placement="top"
                  :ok-text="$t('actionTitles.yes')"
                  :cancel-text="$t('actionTitles.no')"
                  @confirm="handleDelete(record, 'pano')"
                  v-if="
                    isTeam == 0 ||
                    (isTeam && (userInfo.is_team_admin || teamType == 1))
                  "
                >
                  <template slot="title">
                    {{ $t('message.softDeleteHint') }}
                  </template>
                  <a style="color: red">{{ $t('actionTitles.delete') }}</a>
                </a-popconfirm>
              </span>
            </div>
            <div v-else>
              <span v-if="record.dir_id == undefined">
                <a-popconfirm
                  placement="top"
                  :ok-text="$t('actionTitles.yes')"
                  :cancel-text="$t('actionTitles.no')"
                  @confirm="deleteAsync(record.id)"
                >
                  <template slot="title">
                    {{ $t('message.deleteHint') }}
                  </template>
                  <a style="color: red">{{ $t('actionTitles.delete') }}</a>
                </a-popconfirm>
              </span>
            </div>
          </template>
        </a-table-column>
      </a-table>
      <!-- 支付返回的html -->
      <div class="payForm" v-show="false" v-html="payHtml"></div>
    </div>
    <!-- 物件編號 -->
    <a-modal v-model="thingNoVisible" title="物件編號" :destroyOnClose="true">
      <div style="display: flex; justify-content: center">
        <a-input
          v-model="selectThingData.thing_no"
          placeholder="請輸入物件編號"
          style="width: 75%"
        ></a-input>
      </div>
      <template slot="footer">
        <a-button
          v-if="selectThingData.bindStatus == 'edit'"
          key="back"
          @click="handleCancelBindThingNumber"
        >
          取消綁定
        </a-button>
        <a-button key="submit" type="primary" @click="clickBindThingNo">
          綁定
        </a-button>
      </template>
    </a-modal>
    <a-modal
      :title="modelTitle"
      :visible="exitVisible"
      @ok="save"
      @cancel="exitVisible = false"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      keyboard
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :form="form"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 15 }"
        :okText="$t('actionTitles.ascertain')"
        :cancelText="$t('actionTitles.cancel')"
      >
        <a-form-model-item ref="name" :label="$t('edit.name')" prop="name">
          <a-input
            v-model="form.name"
            :placeholder="$t('form.common.field.createFolder.placeholder')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      v-model="treeVisible"
      :title="$t('actionTitles.moveTo')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="moveTo"
    >
      <a-directory-tree
        :loadedKeys="loadedKeys"
        :replaceFields="{ children: 'children', title: 'name', key: 'id' }"
        :load-data="onLoadData"
        :tree-data="treeData"
        :selectedKeys="selectedKeys"
        @select="onSelect"
      />
    </a-modal>

    <a-modal
      v-model="shareVisible"
      :title="$t('actionTitles.share')"
      :width="800"
      :destroyOnClose="true"
      @ok="() => (this.shareVisible = false)"
    >
      <share :share-type="shareType" :work-id="shareWorkId"></share>
    </a-modal>

    <a-modal
      v-model="designateVisible"
      :title="$t('actionTitles.selectUser')"
      :destroyOnClose="true"
      @ok="saveDesignate"
      @cancel="cancelDesignate"
    >
      <div class="change-member-box">
        <div>
          <a-row class="account-box" :gutter="12">
            <a-col
              :span="12"
              v-for="(item, index) in teamUserList"
              :key="index"
              @click="selectTeamUser(item)"
            >
              <div
                class="lists"
                :class="
                  selectTeamUserIds.indexOf(item.user_id) !== -1 ? 'active' : ''
                "
              >
                <img :src="item.avatar ? item.avatar : avatar" />
                <div class="contents">
                  <h4>{{ item.user_team_name }}</h4>
                  <h5>{{ item.phone }}</h5>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-modal>

    <a-modal
      v-model="talkVisible"
      :title="$t('actionTitles.talk')"
      :width="850"
      :destroyOnClose="true"
      :footer="null"
      @ok="() => (this.talkVisible = false)"
    >
      <a-table
        :data-source="talkData.data"
        :loading="talkLoading"
        :pagination="talkPagination"
        rowKey="id"
        @change="handleTalkTableChange"
      >
        <a-table-column
          key="nickname"
          :title="$t('table.common.thead.reviewer')"
          data-index="nickname"
          align="center"
        >
          <template slot-scope="text, record">
            <div class="talk-reviewer">
              <img
                :src="
                  record.head_img
                    ? record.head_img
                    : '/ssr/static/images/default_avatar.jpg'
                "
                alt=""
                style="width: 40px; margin-right: 10px"
              />
              <a style="color: #000" :title="record.nickname">
                {{
                  record.nickname.length > 4
                    ? record.nickname.slice(0, 4) + '...'
                    : record.nickname
                }}
              </a>
            </div>
          </template>
        </a-table-column>

        <a-table-column
          key="content"
          :title="$t('table.common.thead.content')"
          data-index="content"
          align="center"
          width="50%"
        ></a-table-column>
        <a-table-column
          key="create_time"
          :title="$t('table.common.thead.createTime')"
          data-index="create_time"
          align="center"
        ></a-table-column>
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
          v-if="
            isTeam == 0 || (isTeam && (userInfo.is_team_admin || teamType == 1))
          "
        >
          <template slot-scope="text, record">
            <span>
              <a-popconfirm
                :cancelText="$t('actionTitles.cancel')"
                :okText="$t('actionTitles.confirm')"
                :title="$t('message.softDeleteHint')"
                @confirm="() => deleteTalk(record.id)"
              >
                <a href="javascript:;" style="color: red">
                  {{ $t(`actionTitles.delete`) }}
                </a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>

    <!--升級畫面-->
    <a-modal
      :visible="payVisible"
      :destroyOnClose="true"
      :width="600"
      :title="$t('updateModel.updateHouse')"
      :footer="null"
      @cancel="closePayModal"
    >
      <div class="pay-wrap">
        <div class="top">
          <h2>{{ $t('updateModel.rules') }}</h2>
          <p>{{ $t('updateModel.slogan') }}</p>
          <p>{{ $t('updateModel.sloganDesc') }}</p>
        </div>
        <div class="swiper-container">
          <swiper
            class="swiper"
            :options="swiperOption"
            ref="mySwiper"
            @slideChange="handleSlideChange"
          >
            <swiper-slide v-for="(image, index) in images" :key="index">
              <img
                class="swiperImage"
                :src="require(`@/assets/${image.path}`)"
              />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev">
              <a-icon type="arrow-left" />
            </div>
            <div class="swiper-button-next" slot="button-next">
              <a-icon type="arrow-right" />
            </div>
          </swiper>
        </div>
        <div class="contents-box">
          <div class="upgradeInstructions">
            <p>
              {{ $t('upgradeInfo.altogether') }}
              <span class="pointGreen">
                <!-- {{ upgradeItem.panorama }} -->
                {{ workPanoCount }}
              </span>
              {{ $t('upgradeInfo.panorama') }}
            </p>
            <span class="directions">
              {{ $t('upgradeInfo.houseInfo') }}
            </span>
          </div>
          <div class="upgradeInstructions upgradeMargin">
            <p>
              {{ $t('upgradeInfo.modelHouse') }}
              <span class="pointGreen">
                {{ upgradeItem.modelOne }}
              </span>
              {{ $t('upgradeInfo.severalGroup') }}
            </p>
            <span>
              <span class="pointRed">
                {{ upgradeItem.points }}
              </span>
              {{ $t('upgradeInfo.housePoint') }}
            </span>
          </div>
          <div class="upgradeInstructions">
            <p>
              {{ $t('upgradeInfo.addPurchase') }}
              <span class="pointGreen">
                {{ excessCount }}
              </span>
              {{ $t('upgradeInfo.severalPicture') }}
            </p>
            <span>
              <span class="pointRed">
                {{ excessCount }}
              </span>
              {{ $t('upgradeInfo.housePoint') }}
            </span>
          </div>
          <hr />
          <div class="upgradeInstructions">
            <p>
              {{ $t('upgradeInfo.total') }}
            </p>
            <span>
              <img class="pIcon" src="@/assets/picon.png" />
              <span class="pointRed">
                {{ totalPoint }}
              </span>
              {{ $t('upgradeInfo.housePoint') }}
            </span>
          </div>

          <div class="upgradeBottom">
            <div class="underCheckBox">
              <input
                type="checkbox"
                name="agree"
                id="agree"
                v-model="agreeChecked"
                :disabled="!allowCheckLabel"
              />
              <label for="agree">
                {{ $t('upgradeInfo.read') }}
              </label>
            </div>
            <div class="buttonContainer">
              <a-button class="cancelPurchase" @click="cancelPurchase">
                {{ $t('actionTitles.cancel') }}
              </a-button>
              <a-button
                type="primary"
                @click="nextStep"
                :disabled="!agreeChecked"
                :class="{ 'button-disabled': !agreeChecked }"
              >
                {{ $t('actionTitles.surePurchase') }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <!-- 支付結果 -->
    <a-modal
      :visible="payResultsVisible"
      :destroyOnClose="true"
      :width="500"
      :title="$t('form.pay.paySure')"
      :footer="null"
    >
      <div class="pay-result-box">
        <div class="content">{{ $t('form.pay.paySureText') }}</div>
        <div class="btns">
          <a-button type="primary" class="sure-btn" @click="surePayResult">
            {{ $t('form.pay.payFinish') }}
          </a-button>
        </div>
        <div class="tips">
          {{ $t('form.pay.payError') }}：{{ siteInfo.phone }}
        </div>
      </div>
    </a-modal>

    <!-- 退件通知 -->
    <a-modal
      :visible="showReturn"
      :width="650"
      :footer="null"
      @cancel="closeReturnInfo"
    >
      <div class="return-Info">
        <img src="@/assets/img/returnError.png" alt="" />
        <p>
          {{ $t('returnNotify.yourHouse') }}
          <span class="incompatible">
            {{ $t('returnNotify.incompatible') }}
          </span>
        </p>
        <p>{{ $t('returnNotify.contact') }}</p>
        <p>
          {{ $t('returnNotify.projectName') }}
          <span class="worksName">
            {{ returnInfo.title }}
          </span>
        </p>
        <a-button type="primary" @click="returnConfirm">
          {{ $t('returnNotify.confirm') }}
        </a-button>
      </div>
      <template #title>
        <span class="returnTitle">{{ $t('returnNotify.notify') }}</span>
      </template>
    </a-modal>

    <!--複製畫面-->
    <a-modal
      :visible="copyVisible"
      :destroyOnClose="true"
      :width="600"
      :title="$t('copyModel.title')"
      :footer="null"
      @cancel="closeCopyModal"
    >
      <div class="pay-wrap">
        <div class="top">
          <h3>
            {{ $t('copyModel.workName') + ': ' }}
            <span style="color: #015c61">{{ copyName }}</span>
          </h3>
          <div style="width: 330px">
            <h3>{{ $t('copyModel.slogan') }}</h3>
            <h3 style="color: red">{{ $t('copyModel.sloganDesc') }}</h3>
          </div>
        </div>
        <div class="contents-box">
          <div class="upgradeBottom">
            <div class="buttonContainer">
              <a-button class="cancelPurchase" @click="closeCopyModal">
                {{ $t('actionTitles.cancel') }}
              </a-button>
              <a-button
                type="primary"
                style="width: 88px"
                @click="nextStepCopy"
              >
                {{ $t('actionTitles.confirm') }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <!--複製失敗畫面-->
    <a-modal
      :visible="copyErrorVisible"
      :destroyOnClose="true"
      :width="600"
      :title="$t('copyModel.title')"
      :footer="null"
      @cancel="closeCopyModal"
    >
      <div class="pay-wrap">
        <div class="top">
          <h3>
            {{ $t('copyModel.workName') + ': ' }}
            <span style="color: #015c61">{{ copyName }}</span>
          </h3>
          <h3></h3>
          <img src="/ssr/static/images/ico/wrong.png" />
          <h3></h3>
          <h3></h3>
          <h3>{{ $t('copyModel.capacityInsufficient') }}</h3>
          <h3 style="color: red">
            {{ $t('copyModel.capacityInsufficientRemark') }}
          </h3>
        </div>
        <div class="contents-box">
          <div class="upgradeBottom">
            <div class="buttonContainer">
              <a-button
                type="primary"
                style="width: 88px"
                @click="closeCopyModal"
              >
                {{ $t('actionTitles.confirm') }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <!--複製成功畫面-->
    <a-modal
      :visible="copySuccessVisible"
      :destroyOnClose="true"
      :width="600"
      :title="$t('copyModel.title')"
      :footer="null"
      @cancel="closeCopyModal"
    >
      <div class="pay-wrap">
        <div class="top">
          <h3>
            {{ $t('copyModel.workName') + ': ' }}
            <span style="color: #015c61">{{ copyName }}</span>
          </h3>
          <h3></h3>
          <img src="/ssr/static/images/ico/right.png" />
          <h3></h3>
          <h3></h3>
          <h3>{{ $t('copyModel.success') }}</h3>
        </div>
        <div class="contents-box">
          <div class="upgradeBottom">
            <div class="buttonContainer">
              <a-button
                type="primary"
                style="width: 88px"
                @click="closeCopyModal"
              >
                {{ $t('actionTitles.confirm') }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
/*eslint-disable*/
import path from 'path';
import ClearSelected from '../../components/ClearSelected';
import {
  getWorkDetail,
  getWorkList,
  createFolder,
  softDelete,
  getTreeDir,
  getFolderDepth,
  moveDir,
  releaseWork,
  deleteAsync,
  recommend,
  queryTalk,
  delTalk,
  queryTeamUser,
  getDesignateList,
  updDesignateList,
  getWork3DPayConfig,
  getWorkPanoCount,
  copyWork,
} from '@/api/work';
import { getInstalmentList, getPayToken, getUpgrade3DWork } from '@/api/member';
import Share from '@/components/Share';
import { bindThingNo, checkThingNoBind } from '@/api/ting';
import { getUserInfo, clearNotice } from '@/api/user';
import router from '@/views/default/member/account/Basic.vue';

import JSZip from 'jszip';
import FileSaver from 'file-saver';
import { getFile } from '@/utils/downloadFile';
import { baseUrl } from '@/config';
import { download } from '@/utils/offlineDownload';
import { mapState } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.min.css';
import Swiper2, { Navigation, Pagination } from 'swiper';
import Swal from 'sweetalert2';

Swiper2.use([Navigation, Pagination]);
const payDefalutItem = {
  item: {},
  type: '',
  amount: 0,
};

const payDefaultData = {
  name: '',
  phone: '',
  address: '',
  email: '',
  invoiceTitle: '個人', //1-個人，2-公司
  invoiceType: 1,
  companyName: '',
  companyNo: '',
};
export default {
  components: {
    ClearSelected,
    Share,
    Swiper,
    SwiperSlide,
    Swal,
  },
  data() {
    return {
      showReturn: false,
      selectedRowKeys: [],
      selectedRows: [],
      searchForm: {
        pid: 0,
        name: '',
        is_public: [],
        order: [],
      },
      pageResult: {},
      loading: false,
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {},
      renameVisible: false,
      exitVisible: false,
      form: {
        name: '',
      },
      modelTitle: '',
      rules: {
        name: [
          {
            required: true,
            message: this.$t('form.folder').field.name.message,
            trigger: 'blur',
          },
        ],
      },
      treeVisible: false,
      selectedKeys: [],
      treeData: [{ id: 0, name: this.$t('moduleTitles.root') }],
      folderDepthList: [],
      selectDirIds: [],
      loadedKeys: [],
      releaseList: [],
      timeout: undefined,
      tableData: [],
      filters: [
        {
          text: `${this.$t('enum.workIsPublic[1]')}`,
          value: '1',
        },
        {
          text: `${this.$t('enum.workIsPublic[0]')}`,
          value: '0',
        },
      ],
      shareVisible: false,
      shareWorkId: 0,
      shareType: 'tour',
      shareThumbPath: '',
      talkVisible: false, //說一說
      talkData: [],
      talkLoading: false,
      queryTalkParams: {
        wid: '',
        current_page: 1,
        per_page: 10,
      },
      talkPagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },

      isTeam: 0, //是否是團隊帳號 0為個人，1為團隊帳號
      teamType: 1, //查看團隊個人還是團隊總作品 1為個人 2為團隊
      workType: 1, //作品類別 1為一般 3為3D
      noticeValue: 0,
      designateVisible: false, //指派
      teamUserList: [], //指派成員列表
      avatar: require('@/assets/default_h.jpg'), //默認頭像
      selectTeamUserList: [], //指派選擇的成員列表
      selectTeamUserIds: [], //指派選擇的成員列表
      designateWorkId: 0, //指派的作品id
      selectThingData: {
        work_id: 0,
        thing_no: '',
        store_id: '',
        store_type: '',
        vr_url: '',
        bindStatus: '',
      },
      thingNoVisible: false,
      copyVisible: false,
      copyErrorVisible: false,
      copySuccessVisible: false,
      copyName: '',
      copyID: 0,
      // 付款相關
      payVisible: false,
      currStep: 0,
      otherList: {
        upgrade: { icon: require('@/assets/img/member_list_7.png') },
      },
      payItem: {
        item: {},
        amount: '',
        type: '',
      },
      payList: [],
      payData: {
        name: '',
        phone: '',
        address: '',
        email: '',
        invoiceTitle: '', //1-個人，2-公司
        invoiceType: 1,
        companyName: '',
        companyNo: '',
      },
      receivingRules: {
        name: [
          {
            required: true,
            message: this.$t('form.receiving.name.message'),
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t('form.receiving.phone.message'),
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: this.$t('form.receiving.address.message'),
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: this.$t('form.invoice.email.message'),
            trigger: 'blur',
          },
        ],
        companyName: [
          {
            required: true,
            message: this.$t('form.invoice.head.message'),
            trigger: 'blur',
          },
        ],
        companyNo: [
          {
            required: true,
            message: this.$t('form.invoice.code.message'),
            trigger: 'blur',
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      currPayType: {},
      btnLoading: false,
      payHtml: '',
      payResultsVisible: false,
      recordID: 0,
      moveLoading: false,
      bannerList: [],
      swiperOption: {
        loop: false,
        initialSlide: 0,
        // grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      images: [
        { path: 'img/01.jpg' },
        { path: 'img/02.jpg' },
        { path: 'img/03.jpg' },
        { path: 'img/04.jpg' },
        { path: 'img/05.jpg' },
        { path: 'img/06.jpg' },
      ],
      upgradeItem: {
        points: '20',
        number: '1',
        modelOne: '1',
      },
      agreeChecked: false,
      insufficient: {
        twenty: '20',
        one: '1',
      },
      returnInfo: {
        title: '全屋記大樓-3D模型屋',
      },
      // userInfo: {},
      workPanoCount: '0',
      excessCount: '0',
      mergedData: [],
      noticeList: [],
      mySwiper: null,
      allowCheckLabel: false,
      realIndex: 0,
      recordStates: {},
      // showNew: true,
      // storedIds: [],
      noticeIds: [],
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    },
    totalPoint() {
      return String(
        parseInt(this.upgradeItem.points) + parseInt(this.excessCount)
      );
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.release != undefined ? true : false, // 禁用項
            name: record.name,
          },
        }),
      };
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      siteInfo: (state) => state.siteConfig.siteInfo,
    }),
    newPayList() {
      let list = [];
      if (this.payItem.item.is_instalment == 0) {
        this.payList.forEach((obj) => {
          if (obj.installment_num == 0) {
            list.push(obj);
          }
        });
      } else {
        list = JSON.parse(JSON.stringify(this.payList));
      }
      return list;
    },
  },
  mounted() {
    this.isTeam = parseInt(this.userInfo.team_id);
    this.loadData();
    this.getReleaseWork();
    this.timeout = setInterval(() => {
      this.getReleaseWork();
    }, 10000);
    this.checkPanorama();
    this.getUserInfo();
  },
  destroyed() {
    //頁面銷毀 銷毀定時任務
    window.clearInterval(this.timeout);
  },
  watch: {
    'upgradeItem.panorama': 'checkPanorama', // 監聽 panorama 的變化
  },
  methods: {
    handleSlideChange() {
      if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
        const realIndex = this.$refs.mySwiper.$swiper.realIndex;
        if (realIndex === this.images.length - 1) {
          this.allowCheckLabel = true;
        } else {
          this.allowCheckLabel = false;
        }
      }
    },
    //是個人帳號獲取相關帳號信息
    getUserInfo() {
      getUserInfo().then((res) => {
        if (res.code) {
          this.accountInfo = res.data;
          console.log('accountInfo個人帳號資訊', this.accountInfo);
          this.defaultValue = res.data.parent_regoin;

          // 將 noticeList 賦值給 this.userInfo.notice_List
          this.noticeList = this.userInfo.notice_List;

          for (const notice of this.noticeList) {
            const id = notice.id;

            this.noticeIds.push(id);
          }
          this.noticeList.forEach((item, index) => {
            console.log(`Notice ${index + 1}:`, item);
          });

          const numberOfNotices = this.noticeList.length;
          console.log(`總共有 ${numberOfNotices} 筆通知`);
        }
      });
    },

    checkPanorama() {
      if (parseInt(this.upgradeItem.panorama) > 15) {
        this.upgradeItem.number = String(
          parseInt(this.upgradeItem.panorama) - 15
        );
        this.upgradeItem.twentyOne = String(
          parseInt(this.upgradeItem.points) + parseInt(this.upgradeItem.number)
        );
      }
    },
    // 關閉通知
    closeReturnInfo() {
      this.showReturn = false;
    },
    returnConfirm() {
      this.showReturn = false;
    },
    //切換團隊
    changeMember(e) {
      this.teamType = e.target.value;
      this.reset();
      this.loadData();
    },
    changeWorkType(e) {
      this.workType = e.target.value;
      this.reset();
      this.loadData();
    },
    recommend(record) {
      console.log('查看用戶');
      let userType = this.$store.getters.userInfo.type;
      if (userType == 1) {
        let workInfo = { id: record.id };
        workInfo.recommend = record.recommend == 1 ? 0 : 1;
        recommend(workInfo).then((res) => {
          this.loadData();
        });
      }
    },
    onClickEdit(record) {
      this.$router.push({ path: '/edit', query: { id: record.id } });
      // window.location.href = "/edit?id=" + record.id;
      console.log('Record ID:', record.id);
      // console.log('Record:', record)
    },
    onLoadData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        } else {
          setTimeout(() => {
            getTreeDir({ pid: treeNode.dataRef.id }).then((res) => {
              if (res.code && res.data.length) {
                // 找出已選的資料夾ID
                let dir = [];
                this.selectedRows.forEach((item) => {
                  if (item.dir_id == undefined) {
                    dir.push(item.id);
                  }
                });
                // 清除自己所屬之資料夾
                let data = res.data.filter((item) => {
                  if (!dir.includes(item.id)) {
                    return item;
                  }
                });

                if (data.length) {
                  treeNode.dataRef.children = data;
                } else {
                  treeNode.dataRef.isLeaf = true;
                }
              } else {
                treeNode.dataRef.isLeaf = true;
              }
              this.treeData = [...this.treeData];
              resolve();
            });
          }, 1);
        }
      });
    },
    getReleaseWork() {
      releaseWork().then((res) => {
        if (res.data.length <= 0) {
          window.clearInterval(this.timeout);
        }
        this.loadData();
        this.releaseList = res.data.map((item) => {
          item.release = 1;
          return item;
        });
        this.mergeTableData();
      });
    },
    mergeTableData() {
      let mergedData = [];
      if (
        this.pageResult.records == undefined ||
        this.pageResult.records.length <= 0
      ) {
        this.pagination.pageSize = this.releaseList.length;
        this.tableData = [...this.releaseList];
      } else if (this.releaseList.length <= 0) {
        this.tableData = [...this.pageResult.records];
      } else {
        this.pagination.pageSize = 10 + this.releaseList.length;
        this.tableData = [...this.releaseList, ...this.pageResult.records];
      }
    },
    deleteAsync(id) {
      deleteAsync({ id: id }).then((res) => {
        if (res.code) {
          this.$message.success(this.$t('message.deleteSuccess'));
          this.getReleaseWork();
        }
      });
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
    },
    rowKey(record) {
      if (record.release === undefined) {
        if (record.dir_id === undefined) {
          return 'dir:' + record.id;
        } else {
          return record.id;
        }
      } else {
        return 'release:' + record.id;
      }
    },
    customRow(record, index) {
      let _self = this;
      return {
        on: {
          dblclick: function () {
            if (record.dir_id == undefined) {
              _self.searchForm.pid = record.id;
              _self.pagination.current_page = 1;
              _self.loadData();
            }
          },
        },
      };
    },
    toFolder(record) {
      this.searchForm.pid = record.id;
      this.pagination.current_page = 1;
      this.pagination.current = 1;
      this.loadData();
    },
    handleRename(row) {
      this.form = { ...{} };
      setTimeout(() => {
        this.$refs['ruleForm'].resetFields();
        this.form = { ...row };
      }, 0);
      this.exitVisible = true;
      this.modelTitle = this.$t('model.folder.renameTitle');
      // this.form = {...row};
    },
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          createFolder(this.form)
            .then((res) => {
              this.loadData();
              this.$message.success(this.$t('message.saveSuccess'));
              this.exitVisible = false;
            })
            .catch((err) => {
              this.$message.error(err);
            });
        }
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      if (Object.keys(filters).length > 0) {
        this.searchForm.is_public = filters.is_public;
      }
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == 'ascend' ? 'asc' : 'desc';

        let order = {};
        order[field] = orderStr;
        this.searchForm.order = order;
      }
      this.loadData();
      console.log('pagination', this.pagination);
    },
    handleDelete(record, type) {
      this.selectThingData.work_id = record.id;
      this.selectThingData.thing_no = record.thing_no;
      this.selectThingData.store_id = this.userInfo.store_id;
      this.selectThingData.store_type = this.userInfo.store_type;
      this.selectThingData.vr_url = `https://www.qwhouse720.com/tour/${record.uuid}`;
      this.handleCancelBindThingNumber();

      let deletelist = [{ id: record.id, type: type }];
      softDelete(deletelist).then((res) => {
        this.$message.success(this.$t('message.deleteSuccess'));
        this.loadData();
      });
    },
    loadData() {
      this.loading = true;
      this.searchParam = {
        type: this.isTeam ? this.teamType : 1,
        work_type: this.workType,
        ...this.searchForm,
        ...{ current_page: this.pagination.current, per_page: 10 },
      };
      getWorkList(this.searchParam)
        .then((ret) => {
          this.loading = false;
          this.pageResult = ret.data;
          // this.tableData = ret.data.records;
          this.pagination.total = ret.data.total;
          this.selectedRowKeys = [];
          this.selectedRows = [];
          this.mergeTableData();
          // const records = ret.data.records;

          // for (const record of records) {
          //   const id = record.id;

          //   this.storedIds.push(id);
          // }
          // console.log(this.storedIds);
        })
        .catch(() => {
          this.loading = false;
        });
      getFolderDepth({ id: this.searchParam.pid }).then((res) => {
        if (res.code) {
          this.folderDepthList = res.data;
        }
      });
      // 拿取付款相關資訊
      getInstalmentList()
        .then((res) => {
          if (res.code == 1) {
            this.payList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.setWork3DPayConfig();
    },
    createFolder() {
      setTimeout(() => {
        this.$refs['ruleForm'].resetFields();
        this.form = { ...{ name: '', pid: 0 } };
        this.form.pid = this.searchForm.pid;
      }, 0);
      this.exitVisible = true;
      this.modelTitle = this.$t('model.folder.addTitle');
    },
    handleChange(val) {
      if (this.selectedRows.length <= 0) {
        this.$message.warning(this.$t('message.selectHint'));
        return;
      }
      let list = [];
      let dirList = [];
      let panoList = [];
      let dirIds = [];
      this.selectedRows.forEach((item) => {
        if (item.dir_id == undefined) {
          dirList.push({ id: item.id, type: 'dir' });
          dirIds.push(item.id);
        } else {
          panoList.push({ id: item.id, type: 'pano' });
        }
      });
      list = [...dirList, ...panoList];
      if (val.key === 'delete') {
        softDelete(list).then((res) => {
          this.$message.success(this.$t('message.deleteSuccess'));
          this.loadData();
        });
      } else if (val.key === 'offlineDownload') {
        //離線下載
      } else {
        //移動到
        this.selectDirIds = dirIds;
        (this.treeData = [{ id: 0, name: this.$t('moduleTitles.root') }]),
          (this.treeVisible = true);
        this.selectedKeys = [];
        this.loadedKeys = [];
      }
    },
    queryByPid(pid) {
      this.searchForm.pid = pid;
      this.loadData();
    },
    async moveTo() {
      if (this.selectedKeys.length <= 0) {
        this.$message.warning(this.$t('message.moveSelectHint'));
        return;
      }
      if (this.moveLoading) return false;
      this.moveLoading = true;
      let dir = [];
      let pano = [];
      this.selectedRows.forEach((item) => {
        if (item.dir_id == undefined) {
          dir.push(item.id);
        } else {
          pano.push(item.id);
        }
      });
      if (dir.length) {
        //取得第二和第三層資料夾ID
        let target = this.treeData[0].children;
        let allDeep3ID = [];
        let allDeep2ID = [];
        if (target) {
          for (let i = 0; i < target.length; i++) {
            allDeep2ID.push(target[i].id);
            if (target[i]?.children) {
              for (let j = 0; j < target[i].children.length; j++) {
                allDeep3ID.push(target[i].children[j].id);
              }
            }
          }
        }
        //取得移動目標是否包含資料夾
        let payload = {
          current_page: 1,
          name: '',
          is_public: [],
          order: [],
          per_page: 10,
          pid: 0,
          type: this.isTeam ? this.teamType : 1,
          work_type: this.workType,
        };
        let hasDir = false;
        for (let index = 0; index < dir.length; ) {
          payload.pid = dir[index];
          await getWorkList(payload)
            .then((res) => {
              if (res.code === 1) {
                hasDir = res.data.records.some((item) => item.pid);
              }
            })
            .catch((error) => {
              console.log('error', error);
            });
          if (hasDir) {
            break;
          } else {
            // 延遲callAPI時間
            await new Promise((resolve) => {
              setTimeout(() => {
                index++;
                resolve();
              }, 200);
            });
          }
        }
        //當移動作品包括資料夾時，移動後不可超出三層資料夾
        if (
          allDeep3ID.includes(this.selectedKeys[0]) ||
          (allDeep2ID.includes(this.selectedKeys[0]) && hasDir)
        ) {
          this.$message.warning(this.$t('message.moveFail'));
          this.moveLoading = false;
          return false;
        }
      }
      let param = { to: this.selectedKeys[0], dir, pano };
      moveDir(param).then((res) => {
        this.$message.success(this.$t('message.moveSuccess'));
        this.treeVisible = false;
        this.loadData();
        this.moveLoading = false;
      });
    },
    copy(item) {
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', item.thumb_path);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message.success(this.$t('message.copySuccess'));
      }
      document.body.removeChild(input);
    },
    share(item) {
      console.log('share======>', item);
      this.shareType = item.type == 2 ? 'live' : 'tour';
      this.shareWorkId = item.uuid;
      this.shareThumbPath = item.thumb_path;
      this.shareVisible = true;
    },
    showNew(record) {
      let noticeIds = this.noticeIds;
      return noticeIds.includes(record.id) && this.workType === 3;
    },
    toTour(record) {
      const { href } = this.$router.resolve({
        path: (record.type == 2 ? '/live/' : '/tour/') + `${record.uuid}`,
      });
      window.open(href, '_blank');
      const noticeId = record.id;
      if (this.workType == 3) {
        window.location.reload();
      }

      clearNotice({ wid: [noticeId] }).then((response) => {
        // 在清除通知成功后，从 storedIds 中移除对应的 id
        const indexToRemove = this.storedIds.indexOf(noticeId);
        if (indexToRemove !== -1) {
          this.storedIds.splice(indexToRemove, 1);
        }
        // 强制刷新组件
        this.$forceUpdate();
        // window.location.reload();
      });
      // .catch(error => {
      //   console.error('通知清除失敗', error);
      // });
    },

    offlineDownload(record) {
      download(record);
    },
    search() {
      this.reset();
      this.loadData();
    },
    reset() {
      this.pagination.current = 1;
    },
    //說一說
    onClickTalk() {
      this.talkLoading = true;
      let queryTalkParams = {
        ...this.queryTalkParams,
        ...{
          current_page: this.talkPagination.current,
          per_page: this.talkPagination.pageSize,
        },
      };
      queryTalk(queryTalkParams)
        .then((res) => {
          if (res.code === 1 && res.data.data.length) {
            console.log('說一說=', res);
            this.talkLoading = false;
            this.talkData = res.data;
            this.talkPagination.total = res.data.total;
            this.talkVisible = true;
          } else {
            this.talkLoading = false;
            this.talkPagination.total = res.data.total;
            this.talkVisible = true;
            this.talkData = [];
          }
        })
        .catch((err) => {
          this.talkLoading = false;
          console.log('queryTalk err=', err);
        });
    },
    deleteTalk(Tid) {
      delTalk({ id: Tid })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t('message.deleteSuccess'), 2, () => {
              this.talkPagination.current = 1;
              this.onClickTalk();
            });
          }
        })
        .catch((err) => {
          console.log('delTalk err =', err);
        });
    },
    handleTalkTableChange(pagination, filters, sorter) {
      this.talkPagination = pagination;
      // if (Object.keys(sorter).length > 0) {
      //   let field = sorter.field;
      //   let orderStr = sorter.order == "ascend" ? "asc" : "desc";
      //   let order = {};
      //   order[field] = orderStr;
      //   this.queryTalkParams.order = order;
      // }
      this.onClickTalk();
    },
    talk(wid) {
      this.queryTalkParams.wid = wid;
      this.talkPagination.current = 1;
      this.onClickTalk();
    },
    designate(record) {
      console.log(record);
      this.designateVisible = true;
      this.designateWorkId = record.id;
      queryTeamUser().then((res) => {
        if (res.code === 1) {
          this.teamUserList = res.data.user_list;
          if (this.teamUserList.length > 0) {
            for (let i = 0; i < this.teamUserList.length; i++) {
              if (this.teamUserList[i].user_id === this.userInfo.id) {
                this.teamUserList.splice(i, 1);
              }
            }
          }
        }
      });
      getDesignateList({ work_id: this.designateWorkId }).then((res) => {
        if (res.code === 1) {
          for (let i = 0; i < res.data.length; i++) {
            this.selectTeamUserIds.push(res.data[i].user_id);
          }
        }
      });
    },
    selectTeamUser(item) {
      let index = this.selectTeamUserIds.indexOf(item.user_id);
      if (index === -1) {
        this.selectTeamUserIds.push(item.user_id);
      } else {
        this.selectTeamUserIds.splice(index, 1);
      }
      console.log(this.selectTeamUserIds);
    },
    cancelDesignate() {
      this.selectTeamUserIds = [];
      this.designateWorkId = 0;
    },
    saveDesignate() {
      updDesignateList({
        work_id: this.designateWorkId,
        user_ids: this.selectTeamUserIds,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success('指派成功');
          this.designateVisible = false;
        }
        console.log(res);
      });
      console.log(this.selectTeamUserIds);
    },
    clickThingNo(record, bindStatus) {
      this.selectThingData.work_id = record.id;
      this.selectThingData.thing_no = record.thing_no;
      this.selectThingData.store_id = this.userInfo.store_id;
      this.selectThingData.store_type = this.userInfo.store_type;
      this.selectThingData.vr_url = `https://www.qwhouse720.com/tour/${record.uuid}`;
      this.selectThingData.bindStatus = bindStatus;
      this.thingNoVisible = true;
      console.log('this.selectThingData:', this.selectThingData);
      console.log('record:', record);
    },
    handleCancelBindThingNumber() {
      let that = this;
      that.selectThingData.thing_no = '';
      // 確認是否有綁定
      checkThingNoBind(this.selectThingData).then((res) => {
        if (res.data.isBind == 1) {
          bindThingNo(that.selectThingData).then((res) => {
            that.$message.success(that.$t('message.saveSuccess'));
            that.thingNoVisible = false;
            that.loadData();
          });
          // this.$confirm({
          //   title: "取消綁定？",
          //   content: "繼續此操作將清除原有綁定，是否繼續？",
          //   okText: "確認",
          //   cancelText: "取消",
          //   onOk() {
          //     bindThingNo(that.selectThingData).then((res) => {
          //       that.$message.success(that.$t("message.saveSuccess"));
          //       that.thingNoVisible = false;
          //       that.loadData();
          //     });
          //   },
          // });
        } else {
          that.$message.error(that.$t('message.saveFail'));
        }
      });
      this.thingNoVisible = false;
    },
    clickBindThingNo() {
      console.log('clickBindThingNo');
      let that = this;
      checkThingNoBind(this.selectThingData)
        .then((res) => {
          if (res.data.isBind == 1) {
            this.$confirm({
              title: '確認綁定？',
              content: '繼續此操作將清除原有綁定，是否繼續？',
              okText: '確認',
              cancelText: '取消',
              onOk() {
                bindThingNo(that.selectThingData).then((res) => {
                  that.$message.success(that.$t('message.saveSuccess'));
                  that.thingNoVisible = false;
                  that.loadData();
                });
              },
            });
          } else {
            bindThingNo(that.selectThingData).then((res) => {
              that.$message.success(that.$t('message.saveSuccess'));
              that.thingNoVisible = false;
              that.loadData();
            });
          }
          console.log(res);
        })
        .catch((error) => {
          that.$message.error(that.$t('message.saveFail'));
          console.log('checkThingNoBind的error:', error);
        });
    },
    // 設定付款資訊
    setWork3DPayConfig() {
      getWork3DPayConfig({}).then((res) => {
        if (res.code === 1) {
          this.payItem.type = this.otherList['upgrade'].icon;
          this.payItem.item = res.data[0];
          this.payItem.amount = res.data[0].amount;
        }
      });
    },
    copy(data) {
      this.copyID = data.id;
      this.copyVisible = true;
      this.copyName = data.name;
    },
    closeCopyModal() {
      this.copyVisible = false;
      this.copyErrorVisible = false;
      this.copySuccessVisible = false;
    },
    nextStepCopy() {
      const params = {
        work_id: this.copyID,
      };
      console.log('====get copyWork params====', params);
      this.closeCopyModal();
      copyWork(params)
        .then((res) => {
          if (res.code === 1) {
            this.copySuccessVisible = true;
            this.loadData();
          }
        })
        .catch((err) => {
          console.log(err);
          this.copyErrorVisible = true;
        });
    },
    // 付款相關
    pay3D(data) {
      this.recordID = data.id;
      this.payVisible = true;
      const params = {
        id: this.recordID,
      };
      console.log('====get workPanoCount params====', params);
      getWorkPanoCount(params)
        .then((res) => {
          if (res.code === 1) {
            this.workPanoCount = res.data.workPanoCount;
            this.excessCount = res.data.excessCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closePayModal() {
      this.payVisible = false;
      this.agreeChecked = false;
      this.allowCheckLabel = false;
      setTimeout(() => {
        // this.payItem = payDefalutItem;
        this.currPayType = {};
        this.currStep = 0;
        this.payData = payDefaultData;
      }, 1000);
    },
    //選擇支付方式
    selectPayType(item) {
      this.currPayType = item;
    },
    //計算總額
    totalAmount(amount) {
      let total = Number(amount);
      const percent = Number(this.currPayType.interest);
      if (!isNaN(percent) && !isNaN(total)) {
        let newTotal = total + (total * percent) / 100;
        total = newTotal.toFixed();
      }
      return total;
    },
    // 確定購買
    nextStep() {
      this.payVisible = false;
      const userPoint = this.userInfo.point;
      const totalPoint =
        parseInt(this.upgradeItem.points) + parseInt(this.excessCount);
      console.log('totalPoint', totalPoint);
      const params = {
        work_id: this.recordID,
        buy_num: this.payItem.count,
        pay_config_id: this.payItem.item.id,
        use_point: totalPoint,
      };
      if (userPoint >= totalPoint) {
        getUpgrade3DWork(params)
          .then((res) => {
            if (res.code === 1) {
              this.upgradeWorkInfo = res.data;
              console.log('upgradeWorkInfo 3D作品訊息', this.upgradeWorkInfo);
              // 更新 this.userInfo.point
              this.userInfo.point = this.userInfo.point - totalPoint;

              Swal.fire({
                title: this.$i18n.t('alertMessage.purchaseSuccess'),
                text: this.$i18n.t('alertMessage.workingDays'),
                icon: 'success',
                iconColor: '#015C61',
                confirmButtonText: this.$i18n.t('alertMessage.confirm'),
                confirmButtonColor: '#015C61',
              }).then(() => {
                location.reload();
              });
            }
          })
          .catch((error) => {
            console.error('Error in getUpgrade3DWork:', error);
          });
      } else {
        Swal.fire({
          title: this.$i18n.t('alertMessage.balance'),
          icon: 'info',
          iconColor: 'red',
          html:
            `
        <p style="font-weight: bold;">${this.$i18n.t('alertMessage.currently')}
          <span style="color: #015C61">${userPoint}</span>
          ${this.$i18n.t('alertMessage.point')}</p>
        <p style="font-weight: bold;">${this.$i18n.t('alertMessage.lack')}
          <span style="color: red">${totalPoint - userPoint}</span>
          ${this.$i18n.t('alertMessage.point')}</p>
      ` +
            '<img src="' +
            require('@/assets/img/balance.png') +
            '" alt="圖片"></img>',
          confirmButtonText: this.$i18n.t('alertMessage.topUp'),
          confirmButtonColor: '#015C61',
        }).then(() => {
          this.$router.push({ path: '/member/account/basic' });
        });
      }
    },
    cancelPurchase() {
      this.payVisible = false;
      this.allowCheckLabel = false;
      this.agreeChecked = false;
    },
    //切換發票類型
    changePayInvoiceType(e) {
      this.payData.invoiceType = e;
      this.$refs.invoiceForm.resetFields();
    },
    //送出
    submitPay() {
      // console.log('submitPay record',record)
      this.$refs.invoiceForm.validate((valid) => {
        if (valid) {
          let address = {};
          if (this.payItem.item && this.payItem.item.camera_type > 0) {
            address = {
              name: this.payData.name,
              phone: this.payData.phone,
              address: this.payData.address,
            };
          }
          const invoice_consultation = {
            type: this.payData.invoiceType, //1私人 2公司
            email: this.payData.email,
            identifier: this.payData.companyNo,
            company_name: this.payData.companyName,
          };
          const params = {
            work_id: this.recordID,
            pay_method: 'ecpay_web',
            pay_config_id: this.payItem.item.id,
            buy_num: this.payItem.count,
            instalment_id: this.currPayType.id,
            address,
            invoice_consultation,
          };
          console.log('====get token params====', params);
          this.btnLoading = true;
          getPayToken(params)
            .then((res) => {
              if (res.code == 1) {
                this.payHtml = res.data;
                this.btnLoading = false;
                this.currStep = 2;
              }
            })
            .catch((err) => {
              console.log(err);
              this.btnLoading = false;
            });
        }
      });
    },
    //支付
    payFormSubmit() {
      $('.payForm form').submit();
      this.closePayModal();
      this.payResultsVisible = true;
    },
    //確認結果
    surePayResult() {
      this.payResultsVisible = false;
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },

    //
  },
};
</script>

<style lang="less" scoped>
//支付
.pay-wrap {
  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding: 15px;
    justify-content: center;

    h2 {
      font-weight: bold;
    }

    p {
      font-weight: bold;
    }
  }
}

.swiper-container {
  height: 400px;
  width: 100%;

  .swiperImage {
    display: flex;
    justify-content: center;
    height: 100%;
    width: 100%;
  }

  .swiper-button-next,
  .swiper-button-prev {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.3);
    margin-top: -20px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }

    &:after {
      display: none;
    }
  }
}

.amount-box {
  font-size: 16px;
  color: #000;
  text-align: center;
  padding: 30px 0;

  .amounts {
    color: #be4242;
    margin: 0 8px;
  }
}

.contents-box {
  margin-top: 17px;

  .pay-title {
    font-size: 16px;
    color: #000;
    margin-bottom: 15px;

    .anticon {
      margin-right: 10px;
    }
  }

  .upgradeInstructions {
    font-size: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    span {
      margin-left: auto;
      font-weight: bolder;

      .pointRed {
        color: red;
      }

      .pIcon {
        margin-left: 74%;
      }
    }

    p {
      margin: 0;
      font-weight: bolder;

      .pointGreen {
        color: #015c61;
      }
    }

    .directions {
      font-size: 13px;
    }

    .pIcon {
      width: 10%;
    }
  }

  .upgradeMargin {
    margin-top: 3%;
  }

  .upgradeBottom {
    .underCheckBox {
      display: flex;
      justify-content: center;
      margin: 3% 0 3% 0;
      gap: 1%;
      font-size: 16px;
    }

    input[type='checkbox'] {
      border: 2px solid #015c61;
    }

    input[type='checkbox']:checked {
      border: 2px solid #015c61;
    }

    .buttonContainer {
      display: flex;
      justify-content: center;
      gap: 5%;

      .cancelPurchase {
        width: 88px;
        color: #015c61;
        border-color: #015c61;
      }

      .button-disabled {
        cursor: not-allowed;
        background-color: #015c61;
        color: #fff;
        opacity: 0.5;
      }
    }
  }

  // .customIcon {
  //   color: #015c61;
  // }
  // .customButton {
  //   color: #015c61;
  // }

  .pay-type-list {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 5px;
    border: 1px solid #dedede;
    margin-bottom: 20px;
    cursor: pointer;

    &.active {
      background-color: rgba(13, 149, 232, 0.1);
      border-color: rgba(13, 149, 232, 0.5);
      color: #0d95e8;
    }

    .texts {
      font-size: 12px;
      color: #aaa;
      // margin-left: 5px;
    }

    .btns {
      font-size: 12px;
      display: inline-block;
      background-color: #0d95e8;
      color: #fff;
      height: 22px;
      line-height: 22px;
      border-radius: 11px;
      padding: 0 10px;
      margin-left: 10px;
    }
  }

  .ant-form {
    padding: 20px 20px 1px 20px;
    background-color: #f5f5f5;
  }

  &.last-step {
    padding: 50px 0;

    .amount-boxs {
      text-align: center;
      font-size: 18px;

      .amount {
        color: #be4242;
        margin: 0 5px;
      }

      margin-bottom: 40px;
    }

    .btns {
      display: flex;
      align-items: center;
      justify-content: center;

      .pay-btn {
        margin-left: 20px;
      }
    }
  }
}

.bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;

  .amount {
    color: #be4242;
    margin: 0 8px;
  }

  .btns {
    display: flex;
    align-items: center;

    .ant-btn:last-child {
      margin-left: 20px;
    }
  }
}

//支付結果
.pay-result-box {
  padding: 50px 0 40px 0;

  .content {
    text-align: center;
    margin-bottom: 30px;
  }

  .btns {
    display: flex;
    align-items: center;
    justify-content: center;

    .ant-btn:last-child {
      margin-left: 20px;
    }
  }

  .tips {
    text-align: center;
    font-size: 12px;
    color: #999;
    padding-top: 10px;
  }
}

.toFolder:hover {
  cursor: pointer;
  color: #1890ff;
}

.release .ant-row-flex-middle {
  margin-top: 20px;
}

.release img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  float: left;
}

.release .workName {
  float: left;
}

.release .ant-progress-outer {
  width: 80%;
}

.release .progress {
  font-size: 12px;
  text-align: center;
}

.talk-reviewer {
  display: flex;
  align-items: center;
}

.btn-right-boxs {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;

  .more-operate-btn {
    margin-left: 15px;
  }

  .newFolderBtn {
    background-color: #7101ad;
    border-color: #7101ad;
  }
}

.searchBtn {
  background-color: #7101ad;
  border-color: #7101ad;
}
.searchBtn:hover {
  background-color: #d485ff;
  border-color: #d485ff;
}
.searchBtn:focus {
  background-color: #d485ff;
  border-color: #d485ff;
}

//切換團隊
.change-member-box {
  label {
    font-size: 14px;
    color: #000;
    margin-bottom: 15px;
    display: inline-block;
  }

  .empty-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
    color: #555;
  }

  .account-box {
    .active {
      border: 1px solid #1890ff !important;
    }

    .lists {
      position: relative;
      display: flex;
      align-items: center;
      padding: 15px;
      margin-bottom: 12px;
      border-radius: 10px;
      overflow: hidden;
      border: 1px solid #e8e8e8;
      box-shadow: 0 0 8px 3px rgba(0, 0, 0, 0.03);
      cursor: pointer;

      &:hover {
        background-color: #f9f9f9;
      }

      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        flex-shrink: 0;
        margin-right: 14px;
      }

      .contents {
        h4 {
          font-size: 14px;
          color: #555;
          margin-bottom: 0;
        }

        h5 {
          font-size: 12px;
          color: #aaa;
          margin-bottom: 0;
        }
      }

      & > span {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        padding: 4px 10px;
        background-color: #0d95e8;
        color: #fff;
        font-size: 12px;
        border-radius: 0 0 0 10px;
      }
    }
  }
}

// 退件通知
.return-Info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;

  p {
    font-size: 18px;
    font-weight: bold;
    color: #000000;

    .incompatible {
      color: red;
    }

    .worksName {
      color: #015c61;
    }
  }
}

.newYellow {
  background-color: rgb(255, 181, 23);
  color: #000000;
  padding: 1%;
}

.imgMerge {
  position: relative;
}

.icon3D {
  width: 40%;
  height: auto;
  position: absolute;
  top: -7px;
  left: -7px;
}

.newName {
  display: inline-block;
  width: 200px;
}

.changeWorkTypeBtn {
  background-color: #7101ad;
  border-color: #7101ad;
  color: #ffffff;
}

.saveBtn {
  background-color: #7101ad;
}

.aTag {
  color: #d485ff;
}
</style>
